const ORDERS_PREFIX = '@@orders/';

export const ORDERS_ACTION_TYPES = {
    PUT_ORDER_REQUEST: `${ORDERS_PREFIX}PUT_ORDER_REQUEST`,
    PUT_ORDER_SUCCESS: `${ORDERS_PREFIX}PUT_ORDER_SUCCESS`,
    PUT_ORDER_FAILURE: `${ORDERS_PREFIX}PUT_ORDER_FAILURE`,
    FETCH_ORDER_REQUEST: `${ORDERS_PREFIX}FETCH_ORDER_REQUEST`,
    FETCH_ORDER_SUCCESS: `${ORDERS_PREFIX}FETCH_ORDER_SUCCESS`,
    FETCH_ORDER_FAILURE: `${ORDERS_PREFIX}FETCH_ORDER_FAILURE`,
    CLEAR_ORDER_STATE: `${ORDERS_PREFIX}CLEAR_ORDER_STATE`,
};